import axios from "axios";
import * as Styles from "./TermsInfoStyles";
import { useLocation } from "react-router-dom";
import { Input, Checkbox, Select } from "antd";
import countryCodesJson from "./countryCodes.json";
import { useEffect, useRef, useState } from "react";
import { getOnboardingStorage, setOnboardingStorage } from "../storage";
import { useDispatch, useSelector } from "react-redux";
import * as CoachActions from "redux/coach/coach.actions";
import * as AuthActions from "redux/auth/auth.actions";
import { IS_LOCAL } from "configs/utils";
import { getPreparedRegistrationData } from "../utils";
import { REGISTER_STEP } from "../storage";
import OnboardingLoader from "../wrapper/OnboardingLoader";
import { useRouteNavigation } from "hooks/useRouteNavigation";
import moment from "moment";
import { useNavigationRegistration } from "hooks/useNavigationRegistration";
import ApiCollections from "configs/services/apiCollections";

function TermsInfo({ currentPath }) {
  const { handleNavigate, handleNavigateBack } = useRouteNavigation();
  const [ipAddress, setIpAddress] = useState("");
  const location = useLocation();

  const userDataRef = useRef(null);

  const params = new URLSearchParams(location.search);
  const refParam = params.get("ref");
  const dispatch = useDispatch();
  const coach = useSelector((state) => state.coach.coach);

  const [loading, setLoading] = useState(false);
  const [registrationError, setRegistrationError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [fieldData, setFieldData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dataCheckbox: false,
    termsCheckbox: false,
    selectedCountryCode: "+49",
  });

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();

    // Tap.customer(Email);
  }, []);
  const coach_website_url = IS_LOCAL
    ? "https://sebastian-fci1.foodiary.app"
    : `${window.location.protocol}//${window.location.host}`;

  useEffect(() => {
    if (coach) return;

    dispatch(
      CoachActions.trainerIdRequest({
        formData: { coach_website_url },
        callback: (res) => {
          dispatch(
            CoachActions.coachDataRequest({
              formData: { trainerID: res?.trainerID },
              callback: () => null,
            })
          );
        },
      })
    );
  }, [dispatch, coach]);

  useEffect(() => {
    setValidationErrors({});
  }, [fieldData]);

  const countryCodes = countryCodesJson.map((country) => ({
    ...country,
    label: `${country.flag} ${country.dial_code}`,
    value: country.dial_code,
  }));

  const handleInputChange = (field, newValue) => {
    setFieldData({
      ...fieldData,
      [field]: newValue,
    });
  };

  const validateFields = (fields = fieldData) => {
    const fieldNames = [
      "firstName",
      "lastName",
      "email",
      "phoneNumber",
      "dataCheckbox",
      "termsCheckbox",
    ];
    const errors = {};
    let foundErrors = false;
    errors["firstName"] = !fields["firstName"].length ? "Erforderlich" : null;
    errors["lastName"] = !fields["lastName"].length ? "Erforderlich" : null;
    errors["email"] = !fields["email"].length ? "Erforderlich" : null;
    errors["phoneNumber"] = !fields["phoneNumber"].length
      ? "Erforderlich"
      : null;
    errors["dataCheckbox"] = !fields["dataCheckbox"] ? "Erforderlich" : null;
    errors["termsCheckbox"] = !fields["termsCheckbox"] ? "Erforderlich" : null;

    for (let name of fieldNames) {
      if (errors[name]) foundErrors = true;
    }

    return { ...errors, foundErrors };
  };

  const handleNextPage = () => {
    const validatedFields = validateFields();
    if (validatedFields.foundErrors) {
      return setValidationErrors(validatedFields);
    }

    const storage = getOnboardingStorage();
    const registrationData = getPreparedRegistrationData({
      onboarding_storage: storage,
      coachInfo: coach,
      userInfo: fieldData,
    });
    const obj = {
      ...registrationData,
      birthday: moment(registrationData.birthday, "DD.MM.YYYY").format(
        "YYYY-MM-DD"
      ),
    };
    setLoading(true);

    dispatch(
      AuthActions.registration1Request({
        formValues: obj,
        callback: (response) => {
          if (!response.success) {
            setLoading(false);
            return setRegistrationError(
              response.message || "An error has accured, please try again."
            );
          }
          userDataRef.current = response;
          setOnboardingStorage(REGISTER_STEP, { ...response });
          localStorage.setItem("userEmail", fieldData.email);
          if (location.pathname.includes("onboarding")) {
            return handleNavigate(currentPath);
          }
          const body = {
            template_name: "neue-health-analyse-foodiary-coach",

            template_content: [
              {
                name: "prename",
                content: fieldData.firstName,
              },
              {
                name: "email",
                content: fieldData.email,
              },
              {
                name: "mobile",
                content: fieldData.phoneNumber.startsWith("0")
                  ? fieldData.phoneNumber.slice(1)
                  : fieldData.phoneNumber,
              },
              {
                name: "url",
                content: `${coach_website_url}/health-analyse/plan/start?EID=${fieldData.email}&TID=${coach.trainerID}&FID=${coach.FranchiseID}`,
              },
            ],
            subject: "Du hast eine neue Health Analyse erhalten.",
            from_email: "backoffice@foodiary.app",
            to: [
              {
                email: coach.foodiaryEmail,
                type: "to",
              },
              {
                email: "spam@foodiary.app",
                type: "bcc",
              },
            ],
          };
          dispatch(
            CoachActions.sendTransactionalEmail({
              body,
              callback: (res) => {
                if (res.status == 200 || res?.success) {
                  const data = {
                    trainerID: coach.trainerID,
                    userID: userDataRef.current.$nutritionconcept.userID,
                    lead_source: "Health Analyse",
                    lead_received: moment().format("DD/MM/YYYY"),
                  };
                  ApiCollections.createHealthAnalyse(data).then((res) => {
                    createCustomerOnTapifiliate();
                  });
                } else {
                  setLoading(false);
                  setRegistrationError(
                    res.message || "An error has accured, please try again."
                  );
                }
              },
            })
          );
        },
      })
    );
  };

  const createCustomerOnTapifiliate = async () => {
    const payload = {
      customer_id: fieldData.email,
      referral_code: refParam || coach?.affiliate_code || "ogmwmdy",
      meta_data: {
        Source_vom_Klient: "Health-Analyse",
        vorname_klient: fieldData.firstName,
        nachname_klient: fieldData.lastName,
        email_klient: fieldData.email,
        FranchiseID: coach?.FranchiseID,
        email_coach: coach?.email,
        fullname_coach: coach?.prename + " " + coach?.surname,
        user_agent: navigator.userAgent,
        ip: ipAddress,
        landing_page: window.localStorage.href,
      },
    };

    try {
      const response = await axios.post(
        "https://api.tapfiliate.com/1.6/customers/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Api-Key": "3acc178a1eff97b14cc1b12c00222e070a3a1b91",
          },
        }
      );
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
      handleNavigate(currentPath);
    }
  };

  const goBack = () => {
    handleNavigateBack(currentPath);
  };
  useNavigationRegistration(goBack, handleNextPage);
  if (loading) return <OnboardingLoader />;

  return (
    <div className="step-content">
      <Styles.MainContainer>
        <div className="section-titles-wrapper">
          <div className="primary-title">
            Bitte gib deine persönlichen Daten ein
          </div>
          <div className="accent-subtitle">
            Deine Daten benötigen wir zum ersten des Ernährungsplanes.
          </div>
          {validationErrors ? (
            <div className="error-message">{registrationError}</div>
          ) : (
            ""
          )}
        </div>

        <Styles.TermsContainer>
          <div className="grid">
            <div className="input">
              <div className="label">Vorname</div>
              <Input
                value={fieldData.firstName}
                onChange={(event) =>
                  handleInputChange("firstName", event.target.value)
                }
                placeholder="Vorname"
                status={validationErrors.firstName ? "error" : ""}
              />
              <div className="error-message">{validationErrors.firstName}</div>
            </div>
            <div className="input">
              <div className="label">Nachname</div>
              <Input
                value={fieldData.lastName}
                onChange={(event) =>
                  handleInputChange("lastName", event.target.value)
                }
                placeholder="Nachname"
                status={validationErrors.lastName ? "error" : ""}
              />
              <div className="error-message">{validationErrors.lastName}</div>
            </div>
            <div className="input">
              <div className="label">Mail</div>
              <Input
                value={fieldData.email}
                onChange={(event) =>
                  handleInputChange("email", event.target.value)
                }
                placeholder="E-Mail"
                status={validationErrors.email ? "error" : ""}
              />
              <div className="error-message">{validationErrors.email}</div>
            </div>
            <div className="input">
              <div className="label">Handynummer</div>
              <Input
                addonBefore={
                  <Select
                    showSearch
                    options={countryCodes}
                    onChange={(value) =>
                      handleInputChange("selectedCountryCode", value)
                    }
                    defaultValue={fieldData.selectedCountryCode}
                    filterOption={(input, option) =>
                      option.value.includes(input) ||
                      option.name.toLowerCase().includes(input)
                    }
                  />
                }
                placeholder="Handynummer"
                value={fieldData.phoneNumber}
                onChange={(event) =>
                  handleInputChange("phoneNumber", event.target.value)
                }
                status={validationErrors.phoneNumber ? "error" : ""}
              />
              <div className="error-message">
                {validationErrors.phoneNumber}
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="check-item">
              <Checkbox
                onChange={() =>
                  handleInputChange("dataCheckbox", !fieldData.dataCheckbox)
                }
                checked={fieldData.dataCheckbox}
              />
              <span>
                Ich erkläre mich damit einverstanden, dass meine Daten für die
                Erstellung des individuellen Ernährungskonzeptes verwendet,
                verarbeitet und gespeichert werden dürfen.
              </span>
            </div>
            <div className="error-message">{validationErrors.dataCheckbox}</div>

            <div className="check-item negative-margin">
              <Checkbox
                onChange={() =>
                  handleInputChange("termsCheckbox", !fieldData.termsCheckbox)
                }
                checked={fieldData.termsCheckbox}
              />

              <span>
                Ich habe die{" "}
                <a
                  target="_blank"
                  href="https://foodiary.app/terms/agb-coaching/"
                >
                  AGB
                </a>{" "}
                und die{" "}
                <a
                  target="_blank"
                  href="https://foodiary.app/terms/datenschutz/"
                >
                  Datenschutzbestimmungen
                </a>{" "}
                gelesen und verstanden.
              </span>
            </div>
            <div className="error-message">
              {validationErrors.termsCheckbox}
            </div>
          </div>
        </Styles.TermsContainer>
      </Styles.MainContainer>
    </div>
  );
}

export default TermsInfo;
